import * as React from 'react'
import cn from 'classnames'
import styles from './EntityCard.module.scss'
import { PropsWithRequiredChildren } from '../../../types/helpers'

export type BodyProps = PropsWithRequiredChildren<
  React.ComponentPropsWithoutRef<'div'>
>

export const Body: React.VFC<BodyProps> = (props) => {
  const { className, children, ...restProps } = props

  return (
    <div className={cn(styles.body, className)} {...restProps}>
      {children}
    </div>
  )
}
